import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon, SectionDivider } from './Icons';
export const GuaranteeSection = () => {
  return <section className="py-16 px-4 md:px-8 bg-white" data-id="element-73">
      <div className="max-w-3xl mx-auto" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-brand-cream border-2 border-brand-gold/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-75">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-brand-gold via-brand-green to-brand-gold" data-id="element-76"></div>

          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-white text-brand-gold shadow-md mb-6 relative z-10" data-id="element-77">
            <ShieldIcon className="w-10 h-10" data-id="element-78" />
          </div>

          <h2 className="text-2xl md:text-3xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-79">
            Garantía de Satisfacción de 7 Días
          </h2>

          <p className="text-lg text-brand-charcoal/80 leading-relaxed mb-6" data-id="element-80">
            Prueba el método, lee las guías. Si en una semana no sientes que
            este es el camino correcto, te devuelvo cada céntimo.
          </p>

          <p className="font-serif text-xl font-bold text-brand-green italic" data-id="element-81">
            El riesgo es todo mío.
          </p>
        </motion.div>

        <SectionDivider data-id="element-82" />
      </div>
    </section>;
};